(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-tiers"] && !Shopify.designMode) return;
  try {
    (function () {
    const state = (window.__bundleTiers = window.__bundleTiers || {});

    class BundleTiers extends HTMLElement {
      connectedCallback() {
        try {
          this.data = JSON.parse(this.querySelector('[data-bt-data]').textContent);
        } catch (e) {
          return;
        }
        this.key = this.dataset.sectionId + ':' + this.dataset.productId;
        this.st = state[this.key] || (state[this.key] = { qty: 1, slots: [] });
        this.onClick = (e) => {
          const tier = e.target.closest('.bt__tier');
          if (!tier || !this.contains(tier)) return;
          this.st.qty = Number(tier.dataset.qty);
          this.error('');
          this.render();
        };
        this.onChange = (e) => {
          const sel = e.target.closest('.bt__select');
          if (!sel) return;
          const slot = this.st.slots[Number(sel.dataset.slot)];
          if (slot) slot[Number(sel.dataset.opt)] = sel.value;
          this.error('');
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        // The theme re-renders product info when the variant changes; re-apply the chosen tier afterwards.
        this.onVariant = () => setTimeout(() => this.render(), 0);
        document.addEventListener('variant:update', this.onVariant);
        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        document.removeEventListener('variant:update', this.onVariant);
      }

      form() {
        const section = document.getElementById('shopify-section-' + this.dataset.sectionId) || document;
        return section.querySelector('product-form-component form, form[action*="/cart/add"]');
      }

      currentOpts() {
        const form = this.form();
        const id = form && form.querySelector('[name="id"]');
        const v = id && this.data.variants.find((x) => String(x.id) === String(id.value));
        return v ? v.opts.slice() : this.data.options.map((o) => o.values[0]);
      }

      error(msg) {
        const el = this.querySelector('[data-err]');
        if (el) el.textContent = msg || '';
      }

      render() {
        this.querySelectorAll('.bt__tier').forEach((b) => {
          const on = Number(b.dataset.qty) === this.st.qty;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        const need = Math.max(this.st.qty - 1, 0);
        while (this.st.slots.length < need) this.st.slots.push(this.currentOpts());
        const box = this.querySelector('[data-extras]');
        if (!box) return;
        if (!need || !this.data.options.length) {
          box.hidden = true;
          box.innerHTML = '';
          return;
        }
        const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
        let html = '';
        for (let i = 0; i < need; i++) {
          const picks = this.st.slots[i];
          html += '<div class="bt__slot"><div class="bt__slot-label">' + esc(this.data.itemLabel) + ' ' + (i + 2) + '</div><div class="bt__slot-row">';
          this.data.options.forEach((opt, oi) => {
            html += '<select class="bt__select" data-slot="' + i + '" data-opt="' + oi + '" aria-label="' + esc(opt.name) + ' – ' + esc(this.data.itemLabel) + ' ' + (i + 2) + '">';
            opt.values.forEach((val) => {
              html += '<option value="' + esc(val) + '"' + (picks[oi] === val ? ' selected' : '') + '>' + esc(val) + '</option>';
            });
            html += '</select>';
          });
          html += '</div></div>';
        }
        box.innerHTML = html;
        box.hidden = false;
      }

      extraItems() {
        const need = Math.max(this.st.qty - 1, 0);
        const counts = new Map();
        for (let i = 0; i < need; i++) {
          const picks = this.st.slots[i];
          const v = this.data.variants.find((x) => x.opts.every((o, k) => o === picks[k]));
          if (!v || !v.available) {
            return { error: this.data.itemLabel + ' ' + (i + 2) + ' ' + this.data.unavailable };
          }
          counts.set(v.id, (counts.get(v.id) || 0) + 1);
        }
        return { items: [...counts].map(([id, quantity]) => ({ id, quantity })) };
      }
    }

    if (!customElements.get('bundle-tiers')) customElements.define('bundle-tiers', BundleTiers);

    // Runs before the theme's own submit handler (which listens on document in the capture phase).
    if (!window.__bundleTiersSubmit) {
      window.__bundleTiersSubmit = true;
      window.addEventListener(
        'submit',
        (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (form.dataset.bundlePass === '1') {
            delete form.dataset.bundlePass;
            return;
          }
          const section = form.closest('[id^="shopify-section-"]');
          const picker = section && section.querySelector('bundle-tiers');
          if (!picker || !picker.st || picker.st.qty <= 1 || !form.querySelector('[name="id"]')) return;
          if (form !== picker.form()) return;

          const res = picker.extraItems();
          event.preventDefault();
          event.stopImmediatePropagation();
          if (res.error) {
            picker.error(res.error);
            return;
          }
          picker.error('');
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: res.items }),
          })
            .then((r) => r.json().then((body) => ({ ok: r.ok, body })))
            .then(({ ok, body }) => {
              if (!ok || body.status) {
                picker.error(body.description || body.message || 'Could not add the extra items.');
                return;
              }
              // Let the theme add the main item; its cart refresh then includes the extra items too.
              form.dataset.bundlePass = '1';
              if (form.requestSubmit) form.requestSubmit();
              else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            })
            .catch(() => picker.error('Could not add the extra items. Please try again.'));
        },
        true
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
